import {
  LayoutDashboard,
  FolderKanban,
  BookOpenCheck,
  History,
  Settings as SettingsIcon,
  Users,
  LogOut,
  ChevronDown,
  ShieldAlert,
  CreditCard,
  Crown,
  Menu,
  X,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { SystemCheck } from "@/components/SystemCheck";

const ROLE_LABEL = { readonly: "Read-Only Access · Actions Restricted", reviewer: "Reviewer · Can create & edit", admin: "Admin · Full control" };

// App shell header: mobile menu button, role badge, self-check pill, user menu.
export function TopBar({ user, workspaces, currentWorkspace, currentRole, switchWorkspace, logout, navi, isPlatform, brand, platform, logoSrc, API_BASE, mobileNav, setMobileNav, wOpen, setWOpen, roleBadge }) {
  return (
        <header className="h-14 border-b border-slate-800/80 bg-[#0e1420]/80 backdrop-blur px-3 sm:px-6 flex items-center justify-between gap-2">
          <div className="flex items-center gap-3 min-w-0">
            <button className="lg:hidden p-2 -ml-1 rounded-md text-slate-300 hover:text-amber-400 hover:bg-slate-800/60" onClick={() => setMobileNav(true)} aria-label="Open menu" data-testid="mobile-nav-toggle"><Menu className="w-5 h-5" /></button>
            <ShieldAlert className="w-4 h-4 text-amber-500 hidden sm:block" />
            <span className="label-cap truncate">
              <span className="hidden sm:inline">{ROLE_LABEL[currentRole] || ROLE_LABEL.admin}</span>
              <span className="sm:hidden">{currentWorkspace?.name || currentRole}</span>
            </span>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 text-sm text-slate-300 hover:text-slate-100 p-1" data-testid="user-menu-button">
                <div className="w-8 h-8 sm:w-7 sm:h-7 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center text-xs font-semibold">
                  {(user?.name || "?").slice(0, 1).toUpperCase()}
                </div>
                <span className="hidden sm:inline">{user?.name}</span>
                <ChevronDown className="w-4 h-4 hidden sm:block" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-slate-900 border-slate-700 text-slate-100">
              <DropdownMenuItem
                onSelect={() => {
                  logout();
                  navi("/login");
                }}
                className="cursor-pointer focus:bg-slate-800"
                data-testid="logout-menu-item"
              >
                <LogOut className="w-4 h-4 mr-2" /> Log out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </header>
  );
}
